/* Mobile mega menu drill-down navigation.
 * Works with snippets/mb_nav_rail.liquid: tapping a category slides in a
 * full-screen panel with only that category's groups; tapping a group
 * slides in a panel with only its items. A back control returns one level.
 *
 * Loaded once on initial page render (see snippets/render_bottom.liquid),
 * so it is running before the mobile drawer's tab content (which contains
 * the actual .t4s-mb-dd-stage markup) is fetched and injected via AJAX.
 * Everything here uses event delegation + a MutationObserver instead of
 * per-instance inline script execution, since scripts inserted via
 * innerHTML-style AJAX injection are not guaranteed to run.
 */
(function () {
  'use strict';

  var STAGE_SELECTOR = '.t4s-mb-dd-stage';
  var adopted = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  var adoptedFallback = [];

  function isAdopted(stage) {
    if (adopted) return adopted.has(stage);
    return adoptedFallback.indexOf(stage) !== -1;
  }
  function markAdopted(stage) {
    if (adopted) { adopted.add(stage); }
    else { adoptedFallback.push(stage); }
  }

  function drawerFor(stage) {
    var d = stage.closest('.t4s-drawer');
    return d || document.getElementById('t4s-menu-drawer');
  }

  function adopt(stage) {
    if (isAdopted(stage)) return;
    var drawer = document.getElementById('t4s-menu-drawer') || drawerFor(stage);
    if (drawer && stage.parentNode !== drawer) {
      drawer.appendChild(stage);
    }
    markAdopted(stage);
  }

  function scan(root) {
    var scope = root || document;
    if (scope.querySelectorAll) {
      var found = scope.querySelectorAll(STAGE_SELECTOR);
      for (var i = 0; i < found.length; i++) adopt(found[i]);
    }
  }

  function screensOf(stage) {
    return stage.querySelectorAll('.t4s-mb-dd-screen');
  }

  function closeStage(stage) {
    stage.classList.remove('is-active');
    var screens = screensOf(stage);
    for (var i = 0; i < screens.length; i++) screens[i].classList.remove('is-active');
  }

  function closeAllStages() {
    var stages = document.querySelectorAll(STAGE_SELECTOR + '.is-active');
    for (var i = 0; i < stages.length; i++) closeStage(stages[i]);
  }

  function gotoScreen(stage, key) {
    var target = stage.querySelector('[data-mb-dd-screen="' + key + '"]');
    if (!target) return;
    stage.classList.add('is-active');
    var screens = screensOf(stage);
    for (var i = 0; i < screens.length; i++) {
      if (screens[i] !== target) screens[i].classList.remove('is-active');
    }
    target.classList.add('is-active');
    target.scrollTop = 0;
  }

  document.addEventListener('click', function (e) {
    var openEl = e.target.closest && e.target.closest('[data-mb-dd-open]');
    if (openEl) {
      var key = openEl.getAttribute('data-mb-dd-target') || '';
      var dd = key.split('-c')[0];
      if (!dd) return;
      var stage = document.querySelector('[data-mb-dd-stage="' + dd + '"]');
      if (stage) {
        adopt(stage);
        e.preventDefault();
        gotoScreen(stage, key);
      }
      return;
    }
    var closeEl = e.target.closest && e.target.closest('[data-mb-dd-close]');
    if (closeEl) {
      var stage2 = closeEl.closest(STAGE_SELECTOR);
      if (stage2) {
        e.preventDefault();
        closeStage(stage2);
      }
    }
  });

  // Adopt any stage already present, and watch for ones injected later
  // (the mobile drawer's "Menu" tab content is lazy-loaded via AJAX).
  scan();
  var insertWatcher = new MutationObserver(function (mutations) {
    for (var m = 0; m < mutations.length; m++) {
      var added = mutations[m].addedNodes;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches(STAGE_SELECTOR)) adopt(node);
        scan(node);
      }
    }
  });
  insertWatcher.observe(document.body || document.documentElement, { childList: true, subtree: true });

  // Auto-close any open stage when its drawer closes.
  function watchDrawer(drawer) {
    if (!drawer || drawer.__mbDdWatched) return;
    drawer.__mbDdWatched = true;
    var mo = new MutationObserver(function () {
      var isOpen = drawer.classList.contains('is--opend') || drawer.getAttribute('aria-hidden') === 'false';
      if (!isOpen) closeAllStages();
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'aria-hidden'] });
  }

  function init() {
    var drawer = document.getElementById('t4s-menu-drawer');
    if (drawer) watchDrawer(drawer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
